import { Button } from "react-bootstrap";
import { Cart } from "react-bootstrap-icons";
import "./ButtonAddToCart.scss"
import { useEffect, useState } from "react";
import { useAuth } from "../../services/AuthContext";
import { updateCartData } from "../../services/CartServices";
import { addProductToCart } from "../../services/ProductServices";
import { useNavigate } from "react-router-dom";

export default function ButtonAddToCart ({product, small, updateProduct, onChangeTotal, onVisible, onMessage, setVariantAlert, backToPre}) {
  const {user, cart, updateCart} = useAuth()
  const [total, setTotal] = useState(1)
  const [cantDecrement, setCantDecrement] = useState(true)
  const [minTotal, setMinTotal] = useState(1)
  const navigate = useNavigate()

  const stopProp = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const handleDecrement = (e) => {
    onVisible(false)
    stopProp(e)
    const stock = product.stock ? product.stock : -1
    const newTotal = total - 1;

    setTotal(prev => Number(prev) - 1)

    if ((stock != -1) && (stock < newTotal)) {
      onMessage('¡No hay suficiente stock!');
      onVisible(true);
    }
  }

  const handleIncrement = (e) => {
    onVisible(false)
    stopProp(e)
    const stock = product.stock ? product.stock : -1
    const newTotal = total + 1;
    
    setTotal(prev => Number(prev) + 1)
      
    if ((stock != -1) && (stock < newTotal)) {
      onMessage('¡No hay suficiente stock!');
      onVisible(true);
    }
  }

  const addCart = (e) => {
    stopProp(e)
    const updatedItems = [...cart];
    const idx = cart.findIndex(item => item.producto_id === product.id);
    var f = new FormData();
    f.append("producto_id", product.id);
    if (product.observaciones) {
      f.append("observaciones", product.observaciones);
    }
    f.append("variaciones", JSON.stringify(product.variaciones));

    if (user.isSeller && user.clientSelected) {
      f.append("cliente_id", user.clientSelected);
    }
    if (product.variaciones && product.variaciones.length > 0) {
      const primerConStock = product.variaciones.find(item => item.cantidad !== 0);
      if (idx === -1 && !primerConStock){
        onVisible(true)
        onMessage('Debe elegir al menos una variacion')
        setVariantAlert('danger')
      } else {
        const primerMenorMin = product.variaciones.find(item => item.cantidad < product.minimo_compra && item.cantidad > 0);
        if (primerMenorMin) {
          onVisible(true)
          onMessage('Debe elegir una cantidad mayor o igual a ' + product.minimo_compra)
          setVariantAlert('danger')
        } else {
          addProductToCart(f,user.id)
          .then((data)=>{
            setTotal(minTotal)
            updateCart(data.data)
            if (primerConStock) {
              localStorage.setItem('productoAgregado', JSON.stringify({nombre: product.nombre, img: product.preview}))
            } else {
              onVisible(true)
              onMessage('Se acaba de editar el producto')
              setVariantAlert('success')
            }
            if (backToPre) {
              navigate(sessionStorage.getItem('prevState'))
            }
          })
          .catch(err => console.log(err))
        }
      }
    } else {
      if (validateAmount(total,idx)) {//cantAdd
        if (idx!=-1) {
          updatedItems[idx].cantidad = Number(updatedItems[idx].cantidad) + Number(total);
          updatedItems[idx].subtotal = updatedItems[idx].cantidad * updatedItems[idx].precio * (1-updatedItems[idx].descuento_producto/100) * updatedItems[idx].alicuota;
          updatedItems[idx].observaciones = product.observaciones
          f.append("cantidad", updatedItems[idx].cantidad);
          updateCartData(user.id,f)
          .then(data => {
            updateCart(updatedItems)
            setTotal(minTotal)
            updateProduct(product.id, updatedItems[idx].cantidad)
            localStorage.setItem('productoAgregado', JSON.stringify({nombre: product.nombre, img: product.preview}))
            if (backToPre) {
              navigate(sessionStorage.getItem('prevState'))
            }
          })
          .catch(err => console.log(err))
        } else {
          f.append("cantidad", total);
          f.append("variaciones", '[]');
          addProductToCart(f,user.id)
          .then((data)=>{
            setTotal(minTotal)
            updateCart(data.data)
            updateProduct(product.id,total)
            localStorage.setItem('productoAgregado', JSON.stringify({nombre: product.nombre, img: product.preview}))
            if (backToPre) {
              navigate(sessionStorage.getItem('prevState'))
            }
          })
          .catch(err => console.log(err))
        }
      }
    }
  }

  useEffect(()=>{
    setTotal(user.notAplyMin ? 1 : product.minimo_compra ? product.inCart ? 1 : product.minimo_compra : 1)
    setMinTotal(user.notAplyMin ? 1 : product.minimo_compra ? product.inCart ? 1 : product.minimo_compra : 1)
  },[product.minimo_compra])

  useEffect(()=>{
    setCantDecrement(product.minimo_compra ? total <= product.minimo_compra : total <= 1)
    if (onChangeTotal) {
      onChangeTotal(total)
    }
  },[total])

  const validateAmount = (value,idx) => {
    let valid = true
    onVisible(false)
    if (value === '') {
      setTotal(minTotal)
      valid = false
    } else {
      if (value > 0) {
        if (!user.notAplyMin) {
          if (idx === -1) {
            if ((value < minTotal)) {
              valid = false
            }
          }
        }
      } else {
        valid = false
      }
    }

    if (!valid) {
      setTotal(minTotal);
      onMessage('Debe ingresar una mayor o igual a '+ minTotal)
      onVisible(true)
    } else {
      onVisible(false)
    }
    return valid
  }

  return (
    <div className={`action-container ${small ? 'btn-bordered' : ''}`}>
      {!product.variaciones || (product.variaciones && product.variaciones.length === 0)
        ?
          <div className="counter">
            <button className="control-btn" disabled={cantDecrement} onClick={(e)=>{handleDecrement(e)}}>-</button>
            <div className={`input-container ${small ? 'small' : ''}`}>
              <label>{small ? 'Cant.' : 'Cantidad'}</label>
              <input
                type="number"
                className="input-number"
                value={total}
                min={minTotal}
                onClick={(e)=>stopProp(e)}
                onChange={(e)=>{setTotal(e.target.value)}}
              />
            </div>
            <button className="control-btn" onClick={(e)=>handleIncrement(e)}>+</button>
          </div>
        : null
      }
      <div className={`btn-content ${small ? 'small' : ''}`}>
        <Button onClick={(e)=>{addCart(e)}}>
          {!small ? 'Agregar al carrito' : ''}
          <Cart />
        </Button>
      </div>
    </div>
  )
}